// Service Worker registration utility
export const registerServiceWorker = async (): Promise<void> => {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        // Force the browser to check for SW updates on every page load
        updateViaCache: 'none'
      })

      // Check for updates immediately
      registration.update()

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker is ready - activate it immediately
              // This ensures users get the latest CSS/JS without manual refresh
              newWorker.postMessage({ type: 'SKIP_WAITING' })
              
              // Reload the page to load fresh assets
              console.log('[SW] New content available, reloading...')
              window.location.reload()
            }
          })
        }
      })

      console.log('[SW] Service Worker registered successfully')
    } catch (error) {
      console.error('[SW] Service Worker registration failed:', error)
    }
  }
}

export const unregisterServiceWorker = async (): Promise<void> => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready
      await registration.unregister()
      console.log('[SW] Service Worker unregistered successfully')
    } catch (error) {
      console.error('[SW] Service Worker unregistration failed:', error)
    }
  }
}
